import { useTranslation } from 'react-i18next';
import { Button, IconStartAdornment } from 'components/Button';
import {
  ScreenerEnterDob,
  ScreenerLoadingScreener,
  ScreenerNoScreenerFound,
  ScreenerRunningScreenerQuestions,
} from 'domains/signup/screener/Steps';
import { ScreenerContext } from 'domains/signup/screener/context/screenerContext';

import { DocumentTitle } from 'components/DocumentTitle';
import { ScreenerFinished } from 'domains/signup/screener/Steps/Finished';
import { ScreenerEnterTarget } from 'domains/signup/sharedSteps/EnterTarget';

const BaseScreenerWrapper: React.FC = () => {
  const hasBack = ScreenerContext.useSelector(state => state.can({ type: 'back' }));
  const { send } = ScreenerContext.useActorRef();

  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-full items-center px-24 md:px-0">
      <DocumentTitle>{t('screener.pageTitle')}</DocumentTitle>
      <div className="max-w-[600px] w-full min-h-full self-center py-64 sm-d:py-40">
        {hasBack && (
          <Button
            variant="link"
            startAdornment={<IconStartAdornment name="AngleLeft" />}
            className="mb-24"
            onClick={() => send({ type: 'back' })}
          >
            {t('screener.backButton')}
          </Button>
        )}
        <ScreenerEnterTarget />
        <ScreenerEnterDob />
        <ScreenerLoadingScreener />
        <ScreenerNoScreenerFound />
        <ScreenerRunningScreenerQuestions />
        <ScreenerFinished />
      </div>
    </div>
  );
};

export default BaseScreenerWrapper;
